/**
 * Egy tömb utolsó indexének visszaadása.
 * @template {ReadonlyArray<any>} T
 * @param {T} array - A tömb, aminek az utolsó indexét kérjük.
 * @returns {number} Az utolsó index.
 */
module.exports.getLastIndex = function getLastIndex (array) {
  return array.length - 1
}
